import Dropdown from '../../components/other/NDropdown/Dropdown';
import CellInput from '../../components/form/NCellInput/CellInput';
import Form from '../../components/form/NForm';
import Api from '../../requests/Api';
import SuccessPopup from '../../modules/SuccessPopup/successPopup';
import AgreedPopup from '../../modules/AgreedPopup/agreedPopup';
import 'swiper/css';
import 'swiper/css/pagination';
import './onko.scss';

(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const $dropdownList = document.querySelectorAll('.js-dropdown');
        const $cellInput = document.querySelector('.js-cell');
        const $body = document.querySelector('.body');


        $dropdownList.forEach((dropdown) => {
            new Dropdown(dropdown);
        });

        new CellInput($cellInput);

        const button = document.querySelector('.b-footer__agreement_link2');
        button.addEventListener('click', function () {
            button.classList.toggle('active');
        });

        console.log(111, 'contacts init');
        function onClosePopUp() {

            window.location.reload();
        }

    });
})();
